import React from 'react';

import { StyledAvatar } from 'components/avatars';
import { UnderLinedText } from 'screens/analytics/commonComponents';
import { StyledBox, StyledTooltip } from 'styles/common';

import theme from 'constants/theme';

const NamedAvatar = React.forwardRef(
  (
    {
      imageUrl,
      displayName,
      onDisplayNameClick,
      tooltipText,
      clickable = true,
      size = 'smallest',
      border = null,
      avatarLeftGutter = 2,
      avatarRightGutter = 1,
      displayNameTypographyProps = {},
    },
    ref
  ) => (
    <StyledBox
      display="flex"
      alignItems="center"
      clickable={clickable}
      onClick={onDisplayNameClick}
      maxWidth="100%"
      ref={ref}
    >
      <StyledAvatar
        src={imageUrl}
        size={size}
        variant="circular"
        leftGutter={avatarLeftGutter}
        rightGutter={avatarRightGutter}
        border={border}
      />
      <StyledTooltip title={tooltipText}>
        <UnderLinedText
          color={theme.palette.text.heading}
          leftGutter={1}
          variant="body2"
          truncate
          {...displayNameTypographyProps}
        >
          {displayName}
        </UnderLinedText>
      </StyledTooltip>
    </StyledBox>
  )
);

export default NamedAvatar;
